






import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import UserSearchList from '@/components/user/UserSearchList.vue'

@Component({
  components: {
    UserSearchList,
  },
  computed: {},
})
export default class UserSearch extends Vue {}
